.root {
  height: 56px;
}

.label {
  min-height: 20px;
}

.placeholder {
  height: 100%;
}
